/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Trust_Nosub_BodyInputs */

const en_directory_ai_tools_trust_nosub_body = /** @type {(inputs: Directory_Ai_Tools_Trust_Nosub_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy credits once. They never expire.`)
};

const zh_directory_ai_tools_trust_nosub_body = /** @type {(inputs: Directory_Ai_Tools_Trust_Nosub_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一次性购买积分，永不过期。`)
};

/**
* | output |
* | --- |
* | "Buy credits once. They never expire." |
*
* @param {Directory_Ai_Tools_Trust_Nosub_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_trust_nosub_body = /** @type {((inputs?: Directory_Ai_Tools_Trust_Nosub_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Trust_Nosub_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_trust_nosub_body(inputs)
	return zh_directory_ai_tools_trust_nosub_body(inputs)
});
export { directory_ai_tools_trust_nosub_body as "directory.ai_tools.trust.nosub_body" }